import { render, staticRenderFns } from "./detailAccount.vue?vue&type=template&id=2b3cdb93&scoped=true"
import script from "./detailAccount.vue?vue&type=script&lang=js"
export * from "./detailAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3cdb93",
  null
  
)

export default component.exports